import React, { useEffect, useState } from "react";
import Select from 'react-select';
import StandAloneInput from "../../../../../../components/stand-alone-input";

const CostCenter = (props) => {
  const [costCenterList, setCCList] = useState([]);
  const [selectedCC, setSelected] = useState({});
  const [editDeductBenefits, setEditDeductBenefits] = useState(true);
  const [editIsCertified, setEditIsCertified] = useState(true);
  const [editBuildingType, setEditBuildingType] = useState(true);
  const [editContractReg, setEditContractReg] = useState(true);
  const [editContractRegDef, setEditContractRegDef] = useState(true);

  useEffect(() => {
    setCCList(props.costCenters && props.costCenters.map(cc => ({ ...cc, key: cc.treeName, label: cc.treeName })) || []);
    let selected = costCenterList.find(to => to.key === props.costCenterTreeName);
    setSelected(selected);
  }, [props.costCenterTreeName]);

  function handleSelect(e) {
    setSelected(e);
    return props.onChange(e, "costCenterParent");
  };

  function onValueChange(e, fieldName) {

    return props.onChange(e, fieldName);
  };

  function setEditField(field) {
    switch (field) {
      case "isCertified": {
        setEditIsCertified(!editIsCertified);
        break;
      };
      case "buildingType": {
        setEditBuildingType(!editBuildingType);
        break;
      };
      case "deductBenefits": {
        setEditDeductBenefits(!editDeductBenefits);
        break;
      };
      case "contractReg": {
        setEditContractReg(!editContractReg);
        break;
      };
      case "contractRegDefault": {
        setEditContractRegDef(!editContractRegDef);
        break;
      };
    };
  };
  return (

    <div className="ec_setup_contact reg ">
      <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
        <div className="input_line ssD_fiels">
          <label>CC Tree name</label>
          <Select
            options={costCenterList}
            onChange={handleSelect}
            value={selectedCC}
            placeholder="Select Parent CC"
          >
          </Select>
        </div>
      </div>
      {editIsCertified ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Certified custom field num</label>
            <p className="repordIDCS">
              {props.certifiedJobField || "Custom Field for Certified Job Yes/no"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditField("isCertified")}
            >
              Edit
            </button>
          </div>
        </div>
      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Certified job custom field num</label>
            <StandAloneInput
              value={props.certifiedJobField}
              change={e => onValueChange(e, "isCertified", true)}
              placeholder="Enter Custom field indicating certified job Yes/no"
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditField("isCertified")}
          >
            Close
          </button>
        </div>
      )}
      {editBuildingType ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Building type custom field num</label>
            <p className="repordIDCS">
              {props.buildingTypeField || "Building Type Field"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditField("buildingType")}
            >
              Edit
            </button>
          </div>
        </div>

      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Building type custom field num</label>
            <StandAloneInput
              value={props.buildingTypeField}
              change={e => onValueChange(e, "buildingType", true)}
              placeholder="Enter Custom field for Building Type"
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditField("buildingType")}
          >
            Close
          </button>
        </div>
      )}
      {editDeductBenefits ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Benefit deduction custom field num</label>
            <p className="repordIDCS">
              {props.deductBenefitsField || "Deduct Benefits Field"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditField("deductBenefits")}
            >
              Edit
            </button>
          </div>
        </div>

      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Benefit deduction custom field num</label>
            <StandAloneInput
              value={props.deductBenefitsField}
              change={e => onValueChange(e, "deductBenefits", true)}
              placeholder="Enter Custom field for Deduct Benefits Settings"
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditField("deductBenefits")}
          >
            Close
          </button>
        </div>
      )}
      {editContractReg ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Contract reg field <small>[abbreviation | custom field num]</small></label>
            <p className="repordIDCS">
              {props.contractRegistrationField || "Contract Reg Field"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditField("contractReg")}
            >
              Edit
            </button>
          </div>
        </div>

      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Contract reg field <small>[abbreviation | custom field num]</small></label>
            <StandAloneInput
              value={props.contractRegistrationField}
              change={e => onValueChange(e, "contractReg", true)}
              placeholder="Enter Custom field / abbreviation for Contract Registration"
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditField("contractReg")}
          >
            Close
          </button>
        </div>
      )}
      {editContractRegDef ? (
        <div className="reportId d-flex align-items-center justify-content-between">

          <div className="reportIdField repordIDCS_wd_100">
            <label>Contract Reg Default Value <small>might be left blank</small></label>
            <p className="repordIDCS">
              {props.contractRegDefault || "Contract Reg Default"}
            </p>
          </div>

          <div className="reportIdField">
            <button className="btn reportBtn"
              onClick={() => setEditField("contractRegDefault")}
            >
              Edit
            </button>
          </div>
        </div>

      ) : (
        <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
          <div className="input_line ssD_fiels">
            <label>Contract Reg Defaulat Value <small>might be left blank</small></label>
            <StandAloneInput
              value={props.contractRegDefault}
              change={e => onValueChange(e, "contractRegDefault", true)}
              placeholder="Enter Default Value (optional)"
              id="rprt_inpt"
            ></StandAloneInput>
          </div>
          <button className="btn reportBtn"
            onClick={() => setEditField("contractRegDefault")}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};
export default CostCenter;
